var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Task Manager")]),_c('div',{staticClass:"main-content__task-manager"},[_c('coming-soon')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }